/**
 * Derive a stable, URL-safe Jitsi meeting/room name from a Spaces room id, so the
 * TV and a Remote independently compute the SAME meeting to join. In dev this is
 * just an anonymous alpha.jitsi.net room name; in prod the meeting name maps to
 * the room's real conference (a cutover detail). Kept deterministic + collision-
 * resistant enough for shared-dev use.
 */

export function meetingNameForRoom(roomId: string): string {
    const slug = roomId.toLowerCase().replace(/[^a-z0-9]+/g, '').slice(0, 40);

    return `spaces${slug}`;
}
